// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Legacy 2015 Styles
| If possible, migrate to classes defined in non-legacy css files.
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
div.ezClockerHeader2015 {
  z-index: 9999;
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
  width: 100%;
  top: -2px;
  left: -2px;
  padding-left: 4px;
  padding-right: 4px;
  position: fixed;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
}

div.ezClockerHeader2015NonFixed {
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 8px;
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  color: var(--ezClockerBlack);
  background-color: rgb(255 255 255/40%);
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

div.ezClockerHeaderTransparent2015 {
  /* Full CSS3 Compliant Browsers */
  transition: 200ms ease-in-out;
  transform: scale(0.75, 0.75);
  transform-origin: center top;
  width: 100%;
  top: -2px;
  left: -2px;
  padding-left: 4px;
  padding-right: 4px;
  position: fixed;
  background-color: rgb(15 71 119/80%);
  color: var(--ezClockerWhite);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

table.ezClockerHeader2015 {
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  width: 100%;
}

td.ezClockerHeader2015 {
  border-style: none;
  text-align: left;
  vertical-align: middle;
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
}

td.ezclockerHeader2015Right {
  vertical-align: middle;
  text-align: right;
}

img.ezClockerHeader2015 {
  max-width: 250px;
  border-style: none;
  padding: 8px;
  margin: 0;
  vertical-align: middle;
}

img.ezClockerEmployerHeader2015 {
  padding: 2px;
  margin: 0;
  border-style: none;
  max-width: 110px;
  max-height: 40px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

a.ezClockerHeader2015 {
  cursor: pointer;
  text-decoration: none;
  color: var(--ezClockerWhite);
}

.ezClockerMainMenu2015 {
  padding: 4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-top-width: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

div.ezClockerMainContent2015 {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  overflow: auto;
}

div.fullPageContent2015 {
  margin: 0;
  background-color: var(--ezClockerWhite);
  padding: 0;
  overflow: auto;
}

.notVisible {
  display: none;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ezclocker-page-layout.css"],"names":[],"mappings":"AAAA;;;;iEAAA;AAMA;EACI,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,sCAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,iCAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,gCAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,qBAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAAJ;;AAGA;EACI,SAAA;EACA,uCAAA;EACA,UAAA;EACA,cAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Legacy 2015 Styles\r\n| If possible, migrate to classes defined in non-legacy css files.\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\ndiv.ezClockerHeader2015 {\r\n    z-index: 9999;\r\n    transition: 200ms ease-in-out;\r\n    transform-origin: center top;\r\n    transform: none;\r\n    width: 100%;\r\n    top: -2px;\r\n    left: -2px;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    position: fixed;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n}\r\n\r\ndiv.ezClockerHeader2015NonFixed {\r\n    transition: 200ms ease-in-out;\r\n    transform-origin: center top;\r\n    transform: none;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 8px;\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n    color: var(--ezClockerBlack);\r\n    background-color: rgb(255 255 255 / 40%);\r\n    border-bottom-color: var(--ezClockerBlack);\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\ndiv.ezClockerHeaderTransparent2015 {\r\n    /* Full CSS3 Compliant Browsers */\r\n    transition: 200ms ease-in-out;\r\n    transform: scale(0.75, 0.75);\r\n    transform-origin: center top;\r\n    width: 100%;\r\n    top: -2px;\r\n    left: -2px;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    position: fixed;\r\n    background-color: rgb(15 71 119 / 80%);\r\n    color: var(--ezClockerWhite);\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n    border-bottom-left-radius: 10px;\r\n    border-bottom-right-radius: 10px;\r\n}\r\n\r\ntable.ezClockerHeader2015 {\r\n    border-spacing: 0;\r\n    border-collapse: collapse;\r\n    padding: 0;\r\n    width: 100%;\r\n}\r\n\r\ntd.ezClockerHeader2015 {\r\n    border-style: none;\r\n    text-align: left;\r\n    vertical-align: middle;\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n}\r\n\r\ntd.ezclockerHeader2015Right {\r\n    vertical-align: middle;\r\n    text-align: right;\r\n}\r\n\r\nimg.ezClockerHeader2015 {\r\n    max-width: 250px;\r\n    border-style: none;\r\n    padding: 8px;\r\n    margin: 0;\r\n    vertical-align: middle;\r\n}\r\n\r\nimg.ezClockerEmployerHeader2015 {\r\n    padding: 2px;\r\n    margin: 0;\r\n    border-style: none;\r\n    max-width: 110px;\r\n    max-height: 40px;\r\n    border-top-right-radius: 4px;\r\n    border-top-left-radius: 4px;\r\n}\r\n\r\na.ezClockerHeader2015 {\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    color: var(--ezClockerWhite);\r\n}\r\n\r\n.ezClockerMainMenu2015 {\r\n    padding: 4px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    margin-bottom: 10px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    border-style: solid;\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-top-width: 0;\r\n    border-bottom-right-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\ndiv.ezClockerMainContent2015 {\r\n    margin-top: 4px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    padding: 0;\r\n    overflow: auto;\r\n}\r\n\r\ndiv.fullPageContent2015 {\r\n    margin: 0;\r\n    background-color: var(--ezClockerWhite);\r\n    padding: 0;\r\n    overflow: auto;\r\n}\r\n\r\n.notVisible {\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
